module.exports = __webpack_public_path__ + "media/images/sp/stores/common/icon_instagram-ed110d53cfe7354a8d74320f9c8739ee.png";